module.exports = __webpack_public_path__ + "img/Icon-4_fire.2cbd0f59.svg";